var map = {
	"./bluesky-rounded.svg": "cffa",
	"./facebook-rounded.svg": "e05f",
	"./gmb-rounded.svg": "cc68",
	"./instagram-rounded.svg": "db82",
	"./linkedin-rounded.svg": "978d",
	"./pinterest-rounded.svg": "09e2",
	"./threads-rounded.svg": "dbe3",
	"./tiktok-rounded.svg": "8a27",
	"./tumblr-rounded.svg": "0be0",
	"./twitter-rounded.svg": "1a42",
	"./twitter-x-rounded.svg": "93bc",
	"./youtube-rounded.svg": "bf49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc68";